// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__2u3Vg","navigation":"Footer_navigation__1i91c","nav-icon":"Footer_nav-icon__Uckm1","active":"Footer_active__5J0al"};